var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.99799 0.0836838C1.10957 -0.0278946 1.29047 -0.0278946 1.40205 0.0836838L4.91369 3.59533C4.96769 3.64698 5.01081 3.70892 5.04051 3.77752C5.07092 3.84775 5.0866 3.92347 5.0866 4C5.0866 4.07653 5.07092 4.15225 5.04051 4.22248C5.01081 4.29108 4.96769 4.35302 4.91369 4.40467L1.40205 7.91632C1.29047 8.02789 1.10957 8.02789 0.99799 7.91632C0.886412 7.80474 0.886412 7.62383 0.99799 7.51226L4.51025 4L0.99799 0.487745C0.886412 0.376166 0.886412 0.195262 0.99799 0.0836838Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.2512bcfec810189ca19818b95064738e.svg";
export { ForwardRef as ReactComponent };